module.exports = __webpack_public_path__ + "static/Kayla_Ippongi_Resume-9bf27e190e98434f5d536114b796ca1c.pdf";